import React from 'react';
import TimeSeriesChart, { CHART_COLORS } from './TimeSeriesChart';
import { formatMbps } from './format';
import { mbpsSeries } from './series';
import type { Sample } from './types';

interface PanelProps {
  samples: Sample[];
  timestamps: number[];
  sampleCounts: number[];
  intervalSeconds: number;
}

export default function NetworkPanel({
  samples,
  timestamps,
  sampleCounts,
  intervalSeconds,
}: PanelProps) {
  const received = mbpsSeries(
    samples,
    (snapshot) => snapshot.network.received_bytes,
    intervalSeconds,
    { id: 'received', label: 'Received', color: CHART_COLORS.primary },
  );

  const sent = mbpsSeries(samples, (snapshot) => snapshot.network.sent_bytes, intervalSeconds, {
    id: 'sent',
    label: 'Sent',
    color: CHART_COLORS.secondary,
  });

  return (
    <>
      <TimeSeriesChart
        title="Network throughput"
        timestamps={timestamps}
        sampleCounts={sampleCounts}
        series={[received, sent]}
        formatValue={formatMbps}
      />

      <p className="system-stats__note">Summed across every interface.</p>
    </>
  );
}
